import { Alert, Box, Snackbar, TextField } from "@mui/material";
import { useState } from "react";
import { theme } from "src/theme/theme";
import { trainwellColor } from "src/theme/themePrimitives";
import { FilledButton } from "./FilledButton";

/**
 * Component for the invite link. It has a copy button and a snackbar that
 * shows a success message when the link is copied to the clipboard.
 */
const InviteLink = ({ link }: { link: string }) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(link);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (_event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };
  return (
    <Box width="100%">
      <Box
        style={{
          display: "flex",
          gap: theme.spacing(1),
          marginBottom: theme.spacing(2),
        }}
      >
        <TextField
          sx={{
            "& .MuiInputBase-input": {
              background: `linear-gradient(90deg, ${trainwellColor.secondary3}, ${trainwellColor.primary3})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            },
          }}
          fullWidth
          variant="outlined"
          value={link}
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        <FilledButton
          onClick={handleCopyClick}
          sx={{
            width: "fit-content",
          }}
        >
          Copy
        </FilledButton>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={(event: React.SyntheticEvent) => {
            handleCloseSnackbar(event, "close");
          }}
          severity="success"
          sx={{ width: "100%" }}
        >
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default InviteLink;
